import React from "react";

const CourseOverview2 = ({ retreat }) => {
  const weeks = [
    {
      number: 1,
      title: "Embracing the Pain",
      description:
        "Become able to ground ourselves in our breath and body to create the stability and clarity needed to handle the difficulty of our situation.",
    },
    {
      number: 2,
      title: "Caring Through Illusion",
      description:
        "Learn to move beyond a human-centric view of the world, to break out of our separation and touch a greater wonder and mystery in life.",
    },
    {
      number: 3,
      title: "Living with Courage",
      description:
        "Face our deepest fears about our death and the possible destruction of our civilization to have the peace and energy to respond to big challenges.",
    },
    {
      number: 4,
      title: "Learning to Rest",
      description:
        "A chance to rest & restore, and to reflect on course learnings up until this point.",
    },
    {
      number: 5,
      title: "Brave Dialogue",
      description:
        "Discover strategies for listening and speaking to help us in the challenging dialogues needed to heal relationships and address the climate crisis.",
    },
    {
      number: 6,
      title: "Mastering Mind & Habits",
      description:
        "Explore how mindful psychology and self-observation can help us transform fear, anxiety, and despair, transform our habits, and identify our true aspirations.",
    },
    {
      number: 7,
      title: "Active Dimension",
      description:
        "Identify and nurture the power of community to support us beyond this course and feel empowered to walk in the company of bodhisattvas.",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      {/* <div className="flex flex-col md:flex-row items-center mb-16">
        <img
          src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2023/04/Christiana.jpeg?w=851&ssl=1"
          alt="Christiana Figueres"
          className="w-64 h-64 object-cover rounded-full mb-8 md:mb-0 md:mr-8"
        />
        <div className="md:flex-1">
          <blockquote className="text-xl italic mb-4">
            "We have entered a period unseen before in human history that
            requires all hands and all hearts on deck. Whether you're a climate
            activist, a scientist, a parent, an outdoor enthusiast, or someone
            who simply doesn't know where to begin, this course will help you
            respond to the current crisis from a more grounded, thoughtful,
            connected, and effective position."
          </blockquote>
          <p className="text-right font-semibold">
            - Christiana Figueres, UNFCCC Chair of the Paris Climate Agreement
          </p>
        </div>
      </div>

      <nav className="mb-12">
        <ul className="flex flex-wrap justify-center text-sm text-gray-500">
          <li className="mx-2">JUMP TO →</li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              What the Course Offers
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              What You Will Learn
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              The Teachers
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              Practicalities
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              Price
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              Register
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              FAQ
            </a>
          </li>
          <li className="mx-2">
            <a href="#" className="hover:text-gray-700">
              Subscribe
            </a>
          </li>
        </ul>
      </nav> */}

      <h2 className="text-3xl font-serif text-center mb-12">
        What Will You Learn?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8">
        {retreat?.retreatLearningOutcomes &&
          retreat?.retreatLearningOutcomes.map((week, index) => (
            <div
              key={week.id}
              className={`bg-[#fefbf3] p-6 rounded-lg shadow-md ${
                index === 3 ? "md:col-span-3 lg:col-span-3" : ""
              }`}
            >
              <h3 className="text-xl font-semibold mb-2">{week.title}</h3>
              <h4 className="text-lg font-medium mb-4">{week.subTitle}</h4>
              <p className="text-gray-600">{week.description}</p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CourseOverview2;
